export default import.meta.ROLLDOWN_FILE_URL_EvsEJ$5p6pJFFzCELLx1tA